import React, { ReactElement } from 'react';
import { Collapse as AntCollapse } from 'antd';
import styled from 'styled-components';

interface CustomStyles {
  background?: string;
  collapseHeader?: {
    fontWeight?: fontWeight;
    background?: string;
  };
  collapseContent?: {
    background?: string;
  };
}

interface CollapseSingleProps {
  title: string;
  collapsed?: boolean;
  renderContent?: () => JSX.Element;
  renderTopRight?: () => JSX.Element;
  customStyles?: CustomStyles;
  ghost?: boolean;
}

interface CollapseMultiProps {
  items: { key: string; label: React.ReactNode; children: React.ReactNode }[];
  accordion?: boolean;
  defaultActiveKey?: string | string[];
  ghost?: boolean;
  bordered?: boolean;
  expandIconPosition?: 'start' | 'end';
  customStyles?: CustomStyles;
}

type CollapseProps = CollapseSingleProps | CollapseMultiProps;

function isMultiProps(props: CollapseProps): props is CollapseMultiProps {
  return 'items' in props;
}

function Collapse(props: CollapseProps): ReactElement {
  if (isMultiProps(props)) {
    return (
      <StyledCollapse
        items={props.items}
        accordion={props.accordion}
        defaultActiveKey={props.defaultActiveKey}
        ghost={props.ghost}
        bordered={props.bordered}
        expandIconPosition={props.expandIconPosition}
        customStyles={props.customStyles}
      />
    );
  }

  const { title, renderContent, renderTopRight, collapsed, ghost, customStyles } = props;
  return (
    <StyledCollapse
      ghost={ghost}
      items={[
        {
          key: '1',
          extra: renderTopRight && renderTopRight(),
          label: title,
          children: renderContent && renderContent(),
        },
      ]}
      defaultActiveKey={collapsed ? '1' : ''}
      customStyles={customStyles}
    />
  );
}

const StyledCollapse = styled(AntCollapse)<{ customStyles?: CustomStyles }>`
  &.ant-collapse {
    background: ${props => props.customStyles?.background};
  }

  .ant-collapse-header {
    border-radius: 5px !important;
    background: ${props => props.customStyles?.collapseHeader?.background};
    font-weight: ${props => props.customStyles?.collapseHeader?.fontWeight};
  }

  .ant-collapse-content {
    background: ${props => props.customStyles?.collapseContent?.background};
  }
`;

export default Collapse;
